/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyExternalOrders } from 'app/entities/pharmacy-external-order/pharmacy-external-order.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { SupplierType } from 'app/shared/model/enumerations/supplier-type.model';
import { ConsumerType } from 'app/shared/model/enumerations/consumer-type.model';
import { ShipmentStatus } from 'app/shared/model/enumerations/shipment-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-external-order-shipment.reducer';

export const PharmacyExternalOrderShipmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyExternalOrders = useAppSelector(state => state.pharmacyExternalOrder.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyExternalOrderShipmentEntity = useAppSelector(state => state.pharmacyExternalOrderShipment.entity);
  const loading = useAppSelector(state => state.pharmacyExternalOrderShipment.loading);
  const updating = useAppSelector(state => state.pharmacyExternalOrderShipment.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyExternalOrderShipment.updateSuccess);
  const supplierTypeValues = Object.keys(SupplierType);
  const consumerTypeValues = Object.keys(ConsumerType);
  const shipmentStatusValues = Object.keys(ShipmentStatus);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-external-order-shipment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyExternalOrders({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyExternalOrderShipmentEntity,
      ...values,
      order: pharmacyExternalOrders.find(it => it.id.toString() === values.order?.toString()),
      exportType: clinicalDictionaries.find(it => it.id.toString() === values.exportType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          supplierIdType: 'PHARMACY',
          consumerType: 'PHARMACY',
          shipmentStatus: 'PACKAGED',
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyExternalOrderShipmentEntity,
          order: pharmacyExternalOrderShipmentEntity?.order?.id,
          exportType: pharmacyExternalOrderShipmentEntity?.exportType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyExternalOrderShipment.home.createOrEditLabel"
            data-cy="PharmacyExternalOrderShipmentCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.home.createOrEditLabel">
              Create or edit a PharmacyExternalOrderShipment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-external-order-shipment-id"
                  label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.saleBillId')}
                id="pharmacy-external-order-shipment-saleBillId"
                name="saleBillId"
                data-cy="saleBillId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.purchaseBillId')}
                id="pharmacy-external-order-shipment-purchaseBillId"
                name="purchaseBillId"
                data-cy="purchaseBillId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.refundBillId')}
                id="pharmacy-external-order-shipment-refundBillId"
                name="refundBillId"
                data-cy="refundBillId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.active')}
                id="pharmacy-external-order-shipment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.cursor')}
                id="pharmacy-external-order-shipment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.lastUpdated')}
                id="pharmacy-external-order-shipment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.microSec')}
                id="pharmacy-external-order-shipment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.timestampEntry')}
                id="pharmacy-external-order-shipment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.supplierId')}
                id="pharmacy-external-order-shipment-supplierId"
                name="supplierId"
                data-cy="supplierId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.supplierIdType')}
                id="pharmacy-external-order-shipment-supplierIdType"
                name="supplierIdType"
                data-cy="supplierIdType"
                type="select"
              >
                {supplierTypeValues.map(supplierType => (
                  <option value={supplierType} key={supplierType}>
                    {translate(`tinyMedicRestApp.SupplierType.${supplierType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.consumerId')}
                id="pharmacy-external-order-shipment-consumerId"
                name="consumerId"
                data-cy="consumerId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.consumerType')}
                id="pharmacy-external-order-shipment-consumerType"
                name="consumerType"
                data-cy="consumerType"
                type="select"
              >
                {consumerTypeValues.map(consumerType => (
                  <option value={consumerType} key={consumerType}>
                    {translate(`tinyMedicRestApp.ConsumerType.${consumerType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.shipmentStatus')}
                id="pharmacy-external-order-shipment-shipmentStatus"
                name="shipmentStatus"
                data-cy="shipmentStatus"
                type="select"
              >
                {shipmentStatusValues.map(shipmentStatus => (
                  <option value={shipmentStatus} key={shipmentStatus}>
                    {translate(`tinyMedicRestApp.ShipmentStatus.${shipmentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.consignmentNumber')}
                id="pharmacy-external-order-shipment-consignmentNumber"
                name="consignmentNumber"
                data-cy="consignmentNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.carrierDetails')}
                id="pharmacy-external-order-shipment-carrierDetails"
                name="carrierDetails"
                data-cy="carrierDetails"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.internalShipmentNumber')}
                id="pharmacy-external-order-shipment-internalShipmentNumber"
                name="internalShipmentNumber"
                data-cy="internalShipmentNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.addedById')}
                id="pharmacy-external-order-shipment-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedById')}
                id="pharmacy-external-order-shipment-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.addedByType')}
                id="pharmacy-external-order-shipment-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedByType')}
                id="pharmacy-external-order-shipment-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.billNumber')}
                id="pharmacy-external-order-shipment-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <UncontrolledTooltip target="billNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.billNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.excludeTax')}
                id="pharmacy-external-order-shipment-excludeTax"
                name="excludeTax"
                data-cy="excludeTax"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="excludeTaxLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.excludeTax" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.portCode')}
                id="pharmacy-external-order-shipment-portCode"
                name="portCode"
                data-cy="portCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <UncontrolledTooltip target="portCodeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.portCode" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-external-order-shipment-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.order')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyExternalOrders
                  ? pharmacyExternalOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-external-order-shipment-exportType"
                name="exportType"
                data-cy="exportType"
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.exportType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-external-order-shipment"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyExternalOrderShipmentUpdate;
